import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICompanyJobTitle } from '../../../../message-models/company-job-title.interface';
import { IJobTitleInfo } from '../../../../message-models/job-title.interface';
import { IJobLevelInfo } from '../../../../message-models/job-level.interface';
import { IOperativeTypeInfo } from '../../../../message-models/operative-type.interface';
import { IOperative } from '../../../../message-models/operative.interface';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CompanyJobTitle } from '../../../../message-models/company-job-title.class';

@Component({
  selector: 'app-company-job-role-editor',
  templateUrl: './company-job-role-editor.component.html',
  styleUrls: ['./company-job-role-editor.component.scss']
})
export class CompanyJobRoleEditorComponent implements OnInit {

  @Input() heading: string = "Company Job Role Editor";
  @Input() editing: boolean = false;
  @Input() isEditing: boolean = false;
  @Input() companyJobTitle: ICompanyJobTitle ;
  //@Input() companyJobTitles: CompanyJobTitle[] = [];
  @Input() allJobTitles: IJobTitleInfo[] = [];
  //@Input() allRisks: IRiskInfo[] = [];
  @Input() allJobLevels: IJobLevelInfo[] = [];
  @Input() allOperativeTypes: IOperativeTypeInfo[] = [];
  //@Input() allEmploymentStatuses: IEmploymentStatus[] = [];

  @Input() operative: IOperative;
  saveAttempted: boolean = false;

  //@Output() saveCompanyJobTitleClicked: EventEmitter<ICompanyJobTitle> = new EventEmitter<ICompanyJobTitle>();
  //@Output() cancelCompanyJobTitleClicked: EventEmitter<any> = new EventEmitter<any>();
  showingHelp: boolean = false;





  constructor(public config: DynamicDialogConfig) { }

  ngOnInit(): void {
 
 
  }

   
}
